import { TScanFeatures } from './settings.types';

export const SCAN_FEATURE_NAMES = new Set<TScanFeatures>([
  'scan-intro',
  'scan-method',
  'scan-details',
  'scan-document',
  'scan-gender',
  'scan-preview'
]);
